import { urlIsWhitelisted } from './../../../hx-hostname-whitelist/src/urlIsWhitelisted';
export var createMessageListenerMiddleware = function (messageHandler) {
    return function (store) {
        return function (next) {
            return function (action) {
                window.addEventListener('message', function (event) {
                    var _a, _b;
                    if (!((_b = (_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.startsWith('widget')))
                        return;
                    var hostname = new URL(event.origin).hostname;
                    if (!urlIsWhitelisted(hostname)) {
                        console.error("Host page hostname '".concat(event.origin, "' is not in whitelist '").concat(process.env.REACT_APP_HOSTNAME_WHITELIST, "'"));
                    }
                    else {
                        messageHandler(event, store);
                    }
                    return next(action);
                });
                return next(action);
            };
        };
    };
};
